import { reactive } from 'vue';
import { getDescriptionsByKey } from '@/api/descriptions.js';
import { GET_DESCRIPTION, SET_DESCRIPTION } from '@/store/mutationTypes.js';

const state = reactive({
  activityType: [],
  socialNetworkType: [],
  skillLevel: []
});

const mutations = {
  [SET_DESCRIPTION]: (state, { key, value }) => {
    state[key] = value;
  },
};

// действие принимает первым аргументом context, вторым payload
const actions = {
  [GET_DESCRIPTION]: async function({ commit }, { key, entity }) {
    const { data, success } = await getDescriptionsByKey({ key, entity });

    if (success) {
      commit(SET_DESCRIPTION, { key, value: data.items });
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
